import Base from './base';
import {
  VIDEO_TAG_NAME,
  VIDEO_CLASS_NAME
} from '../../classnames/blog';

export default class Video extends Base {
  tagName = VIDEO_TAG_NAME;

  buildNode = (placeholder) => {
    const videoContainer = document.createElement('div');
    videoContainer.classList.add(VIDEO_CLASS_NAME);
    const video = placeholder.cloneNode(true);
    video.style.display = 'block';
    videoContainer.appendChild(video);
    return videoContainer;
  };
}
